import React, { createContext, useContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

// Contexto para notificações
const NotificationContext = createContext();

export function NotificationProvider({ children, autoHideDuration = 2000 }) {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "info", // 'success', 'error', 'warning', 'info'
    autoHideDuration: autoHideDuration,
  });

  const notify = (message, severity = "info", autoHideDuration = 2000) => {
    setNotification({
      open: true,
      message,
      severity,
      autoHideDuration: autoHideDuration,
    });
  };

  const closeNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  return (
    <NotificationContext.Provider value={notify}>
      {children}
      <Snackbar
        open={notification.open}
        onClose={closeNotification}
        autoHideDuration={notification.autoHideDuration}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          sx={{ display: "flex", alignItems: "center" }}
          onClose={closeNotification}
          severity={notification.severity}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
}

// Hook para usar o contexto
export const useNotification = () => {
  return useContext(NotificationContext);
};
